import React from 'react';
import { useSpareDeliveries } from '../../spares/spare-deliveries/useData';
import { computeSpareDeliveryLinesStatus } from '../../spares/spare-deliveries/deliveryLineIssues';
import { StatusBreakdown, type StatusBreakdownRow } from './shared';

const SparesDeliveryLineStatus: React.FC<{ embedded?: boolean }> = ({ embedded }) => {
  const { data, isLoading } = useSpareDeliveries(undefined, 1, 200);

  const totals = { complete: 0, partial: 0, pending: 0, no_lines: 0 };
  for (const d of data ?? []) {
    const status = computeSpareDeliveryLinesStatus(d.lines);
    totals[status] += 1;
  }

  const rows: StatusBreakdownRow[] = [
    { key: 'complete', label: 'Complete', value: totals.complete, color: 'bg-emerald-500' },
    { key: 'partial', label: 'Partial', value: totals.partial, color: 'bg-amber-500' },
    { key: 'pending', label: 'Outstanding', value: totals.pending, color: 'bg-rose-500' },
    { key: 'no_lines', label: 'No lines', value: totals.no_lines, color: 'bg-slate-400' },
  ];

  return (
    <StatusBreakdown
      title="Spares · Delivery Line Status"
      rows={rows}
      isLoading={isLoading}
      embedded={embedded}
      viewAllPath="/spares/spare-deliveries"
      emptyMessage="No deliveries"
    />
  );
};

export default SparesDeliveryLineStatus;
